import { render, staticRenderFns } from "./BemListPrint.vue?vue&type=template&id=8dc0ba14"
import script from "./BemListPrint.vue?vue&type=script&lang=js"
export * from "./BemListPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports